import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "../../fn";

/**
 * Проверить регистрацию и наличие ЭЦП у пользователи
 * @param subjectId
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const checkEdsInMydss = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/sign/mydss/check/subject/${subjectId}`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

export const mydssRegistrationPerson = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/mydss/registration/person/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

export const mydssGetBlank = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/mydss/getblank/person/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

export const mydssSaveDeviceCode = async (subjectId, deviceCode) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/mydss/savedevicecode/subject/${subjectId}`, {deviceCode}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Удалить документ из заявления на выпуск ЭЦП
 * @returns {Promise<UploadFileResult>}
 */
export const deleteMydssDocument = async (docType, subjectId) => {
  const result = await new Promise((resolve) => {
    axios.delete(`${getBackendURL()}/sign/mydss/documents/${docType}/subject/${subjectId}`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Удалить регистрацию
 * @returns {Promise<UploadFileResult>}
 */
export const deleteMydssRegistration = async (subjectId) => {
  const result = await new Promise((resolve) => {
    axios.delete(`${getBackendURL()}/sign/mydss/registration/subject/${subjectId}`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Загрузить документ субъекта для выпуска ЭЦП
 * @param docType
 * @param formData
 * @param subjectId
 * @returns {Promise<unknown>}
 */
export const uploadMydssDocument = async (docType, formData, subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/mydss/upload/${docType}/subject/${subjectId}`, formData, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Зарегистрировать пользователя в mydss
 * @param subjectId
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const uploadMydssRegistrationDocs = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/mydss/uploaddocs/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Подтвердить пользователя в mydss
 * @param subjectId
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const submitMydssSubject = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/mydss/submit/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}